import React from 'react'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
const Puz36 = () => {
    return (
        <div>
            <NavLink to='/category/Puzzels/Puzzel37'>
<Button variant="contained" color="primary" style={{float:'right', margin:'25px',marginRight:'80px'}}>Next page -&gt; </Button>
</NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<NavLink to='/category/Puzzels/Puzzel35'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'70px'}}>&lt;-   Previous page </Button>
</NavLink>
<article class="container">
    <h1 class="title">Matchstick Puzzle</h1>
   
    <div class="text">
        <p>Question: How to make 4 equilateral triangles with 6 identical match sticks?&nbsp;</p>
        <p>&nbsp;&nbsp;<br/>&nbsp;</p>
        <div className='containers'>
       <p>&nbsp;&nbsp;<br/>Answer: Make a tetrahedron.&nbsp;</p>
        <p>&nbsp;</p>
        <p><img src="https://media.geeksforgeeks.org/wp-content/uploads/tetrahedron-1.png" alt="MatchstickPuzzle"/></p>
        <br/>
        <div id="AP_G4GR_5"></div>
        <br/>
        <p><strong>Method-II:</strong>&nbsp;<br/>&nbsp;</p>
        <p><img src="https://media.geeksforgeeks.org/wp-content/uploads/FourTriangles.png" alt=""/></p>
        <p><strong>Method – III:</strong></p>
        <p>Make one equilateral triangle by three sticks . then put each remaining stick on straight line passing
            through middle points of each two arms of triangle.</p>
        <p>&nbsp;</p>
        <p><img src="https://media.geeksforgeeks.org/wp-content/uploads/20210215124801/trianglegfgcopy12-100x93.png"/>
        </p>
        <p>&nbsp;<strong>Method IV:</strong></p>
        <p><img src="https://media.geeksforgeeks.org/wp-content/uploads/20210611122203/method4-300x299.png"
                srcset="https://media.geeksforgeeks.org/wp-content/uploads/20210611122203/method4.png," sizes="100vw"
                width="300"/></p>
        </div>
    </div>
</article>
        </div>
    )
}

export default Puz36
